import { TarifsContainer } from "../containers/TarifsContainer/TarifsContainer";

export const Tarifs = () => (
    <TarifsContainer/>
)
